/**
 * Single-source feature gate for the /upgrades base-search overhaul UI.
 *
 * When the backend ships PLAN_upgrades_base_search_overhaul (advanced
 * filters, matches[]/matchCount/matchesTruncated, /upgrades/match-detail
 * endpoint, 503/504/invalid_cursor error codes), flip this to `true`.
 *
 * The transport + slice + error-classification changes are
 * backwards-compatible and ship live regardless — they degrade
 * gracefully against the old endpoint shape. This flag only gates the
 * surface area that's visible to users without the new API:
 *
 *   - Advanced Filters panel (would otherwise let users set params the
 *     old endpoint ignores)
 *   - Inline match summary chip on each card tile (would render nothing
 *     anyway, but the empty container has its own border/background)
 *   - "+N more matches" link → match-detail dialog (no matches[] means
 *     no link, but belt-and-suspenders)
 */
export const UPGRADES_BASE_SEARCH_OVERHAUL_ENABLED = false;
